import { render } from "./GetPwd.vue?vue&type=template&id=968d92f8&scoped=true"
import script from "./GetPwd.vue?vue&type=script&lang=js"
export * from "./GetPwd.vue?vue&type=script&lang=js"

import "./GetPwd.vue?vue&type=style&index=0&id=968d92f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-968d92f8"]])

export default __exports__